import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/components/control-button.css';

const ControlButton = ({
  onClick,
  children,
  icon,
  variant = 'primary',
  active = false,
  className = '',
  title,
  ariaLabel,
  round = false
}) => {
  return (
    <button
      className={`control-button control-button-${variant} ${active ? 'active' : ''} ${round ? 'control-button-round' : ''} ${className}`}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel || title}
    >
      {icon && <span>{icon}</span>}
      {children && <span className="control-button-text">{children}</span>}
    </button>
  );
};

ControlButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  icon: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'secondary', 'icon']),
  active: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  round: PropTypes.bool
};

export default ControlButton;